<template>
    <div>
    <header class="header">
        <img v-if="languageIndex == 0" src="/static/img/banner1.png" alt="">
        <img v-else src="/static/img/banner11.png" alt="">
        <navHeader ref=navHeader></navHeader>
    </header>
    <main class="main">
        <nav class="nav">
            <ul>
                <li @click="aboutus()" class="pick pointer_box">{{langtrans().gywmm[languageIndex]}}</li>
                <li @click="news()" class="pointer_box">{{langtrans().xwzzx[languageIndex]}}</li>
                <li @click="league()" class="pointer_box">{{langtrans().qqjylm[languageIndex]}}</li>
                <li @click="stars()" class="pointer_box">{{langtrans().xssffw[languageIndex]}}</li>
            </ul>
        </nav>
        <section class="section">
            <div class="about_box">
                <h3>{{langtrans().gywmm[languageIndex]}}</h3>
                <p>{{langtrans().ddjxsz[languageIndex]}}</p>
                <p>{{langtrans().ddjxzl[languageIndex]}}</p>
                <p>{{langtrans().zqqfwn[languageIndex]}}APP{{langtrans().ddjxkq[languageIndex]}}</p>
            </div>
            <div class="vision_box">
                <h3>{{langtrans().yjy[languageIndex]}}</h3>
                <p>
                    <span>{{langtrans().zzggmq[languageIndex]}}</span>
                    <span>{{langtrans().gbzzgg[languageIndex]}}</span>
                </p>
            </div>
            <div class="mission_box">
                <h3>{{langtrans().ssm[languageIndex]}}</h3>
                <p>{{langtrans().zzggmh[languageIndex]}} {{langtrans().yyqbj[languageIndex]}}</p>
            </div>
        </section>
    </main>
<vFooter @performHeader=performHeader></vFooter>
    </div>
</template>

<script>
import langtrans from "@/assets/languagejs/aboutus.vue.trans.js";
import { Message } from "element-ui";
import constants from "@/util/constants.js";
import navHeader from '@/components/header/indexHeader'
import vFooter from '@/components/footer/indexFooter'
export default {
  data() {
    return {
      flag: true,
      usertype: "",
      user: "",
      pwd: ""
    };
  },
  components:{
  	navHeader,
  	vFooter
  }, 
		computed:{
			languageIndex(){
				return this.$store.state.language
			}
		},	
  methods: {
		langtrans(){
			return langtrans
		},	
  	performHeader(str){
    	this.$refs.navHeader.login(str)
    },
    news() {
      this.$router.push({
        name: "news"
      });
    },
    league() {
      this.$router.push({
        name: "league"
      });
    },
    stars() {
      this.$router.push({
        name: "stars"
      });
    },
    feedback() {
      this.$router.push({
        name: "feedback"
      });
    },
    aboutus() {
      this.$router.push({
        name: "aboutus"
      });
    },
    dowapp() {
      this.$router.push({
        name: "dowapp"
      });
    },
    index() {
      this.$router.push({
        name: "Index"
      });
    },
    contact() {
      this.$router.push({
        name: "contact"
      });
    },
 }
};
</script>

<style scoped>
@import url(../../static/css/global.css);
.section h3 {
  font-size: 1.375vw;
  font-weight: 500;
  color: #333;
}
.section .about_box p {
  font-size: 1vw;
  margin-top: 1.5625vw;
  color: #333;
}
.section .vision_box p,
.section .mission_box p {
  font-size: 1vw;
  margin-top: 1.125vw;
  color: #333;
}
.section .vision_box p span {
  font-size: 1vw;
  display: block;
}
span + span {
  margin-top: 0.5vw;
}
</style>



// WEBPACK FOOTER //
// src/components/aboutus.vue